"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _localization = require("@lt/localization");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FacilitiesItem = _interopRequireDefault(require("../FacilitiesItem"));

var FacilitiesList = function FacilitiesList(_ref) {
  var items = _ref.items,
      _ref$showBestTitle = _ref.showBestTitle,
      showBestTitle = _ref$showBestTitle === void 0 ? false : _ref$showBestTitle,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesList, {
    showBackground: showBestTitle
  }, showBestTitle && /*#__PURE__*/_react["default"].createElement(StyledTitle, null, t('hotel.facilities.best')), /*#__PURE__*/_react["default"].createElement(Container, {
    isMobile: isMobile
  }, items.map(function (_ref2) {
    var text = _ref2.text,
        icon = _ref2.icon;
    return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
      key: text,
      icon: icon
    }, text);
  })));
};

var StyledFacilitiesList = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesList__StyledFacilitiesList",
  componentId: "sc-1cs5i9c-0"
})(["padding:7px 10px;", ""], function (props) {
  return props.showBackground && "\n    background-color: ".concat(props.theme.colors.veryLightPink, ";\n    border-radius: ").concat(props.theme.shape.borderRadiusBig, ";\n    margin-bottom: 7px;\n  ");
});

var StyledFacilitiesItem = (0, _styledComponents["default"])(_FacilitiesItem["default"]).withConfig({
  displayName: "FacilitiesList__StyledFacilitiesItem",
  componentId: "sc-1cs5i9c-1"
})(["flex-basis:25%;"]);

var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesList__StyledTitle",
  componentId: "sc-1cs5i9c-2"
})(["letter-spacing:1px;color:#887e78;text-transform:uppercase;margin-bottom:8px;"]);

var Container = _styledComponents["default"].ul.withConfig({
  displayName: "FacilitiesList__Container",
  componentId: "sc-1cs5i9c-3"
})(["", ""], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return !isMobile && "\n  column-count: 4;\n  ";
});

var _default = /*#__PURE__*/_react["default"].memo(FacilitiesList);

exports["default"] = _default;